import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import AuditlogListComponent from "../components/auditlog/AuditlogListComponent";
import AuditlogShowComponent from "../components/auditlog/AuditlogShowComponent";
import _FM_ReservationFormComponent from "../components/_FM_reservation/_FM_ReservationFormComponent";

const AuditlogPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();

  useEffect(() => {
    document.title = t('monolog') + ' - ' + process.env.REACT_APP_TITLE;
  }, []);

  return (
    <div className="AuditlogPage p-component p-m-lg-4">
      <div className={"p-p-3 p-p-lg-0"}>
        <Panel>
          <AuditlogListComponent />
        </Panel>
        <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
                 style={{width: '780px'}}
                 onHide={() => {
                   navigate(-1);
                 }}>
          <AuditlogShowComponent/>
        </Sidebar>
      </div>
    </div>
  )
}
export default withTranslation('common')(AuditlogPage);
